<template>
  <div id='bd-message'>
    <el-dialog title="查看大图" :modal="false" :visible.sync="imageDialogVisible" width="30%" :before-close="handleImageDialogClose">
      <span><img :src="currentImageUrl" alt="[查看大图]" style="height: 100%; width: 100%;"/></span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="imageDialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="语音播放器" :modal="false" width="30%" :visible.sync="dialogTableVisible">
      <iframe :src="player_url"></iframe>
    </el-dialog>
    <!-- 聊天记录 -->
    <ul class="bd-message-ul" ref="list">
      <li v-for="message in messages" :key="message.mid">
        <p class="timestamp">
          <span>{{ message.createdAt | datetime }}</span><br/>
          <span v-if="is_type_notification(message)">{{ message.content }}</span>
        </p>

        <div v-if="!is_type_notification(message)" class="main" :class="{ self: is_self(message) }">
          <img v-if="show_header" class="avatar" width="30" height="30"
            :src="message.user.avatar"
            @click="imageClicked(message.user.avatar)"/>
          <div class="name">{{ message.user.name }}</div>
          <div v-if="is_type_text(message)" class="text" v-html="replaceFace(message.content)"></div>
          <div v-if="is_type_robot(message)" class="text" v-html="replaceFace(message.content)"></div>
          <div v-if="is_type_questionnaire(message)" class="text">
            <span>{{ message.questionnaire.questionnaireItems[0].title }}</span>
            <span v-for="item in message.questionnaire.questionnaireItems[0].questionnaireItemItems" :key="item.id">
              <br/>
              <span style="color:#007bff; cursor: pointer;" @click="chooseQuestionnaire(item.qid)">{{ item.content }}</span>
            </span>
          </div>
          <div v-if="is_type_company(message)" class="text">
            <span>{{ message.content }}</span>
            <span v-for="item in message.company.countries" :key="item.cid">
              <br/>
              <span style="color:#007bff; cursor: pointer;" @click="chooseCountry(message.company.cid, item.cid)">{{ item.name }}</span>
            </span>
          </div>
          <div v-if="is_type_workGroup(message)" class="text">
            <span>{{ message.content }}</span>
            <span v-for="item in message.workGroups" :key="item.wid">
              <br/>
              <span style="color:#007bff; cursor: pointer;" @click="chooseWorkGroup(item.wid)">{{ item.nickname }}</span>
            </span>
          </div>
          <div v-if="is_type_image(message)" class="text">
            <img :src="message.imageUrl" alt="[图片]"
              style="padding-top: 10px; padding-bottom: 10px; width: 100px; height: 100px;"
              @click="imageClicked(message.imageUrl)"/>
          </div>
          <div v-if="is_type_file(message)" class="text">
            <img src="https://cdn.bytedesk.com/img/input/file.png" alt="[文件]"
              style="padding-top: 10px; padding-bottom: 10px; width: 25px; height: 25px;"
              @click="fileClicked(message.fileUrl)"/>
            <span><a :href="message.fileUrl" target="_blank">查看文件</a></span>
          </div>
          <div v-if="is_type_voice(message)" class="text">
            <img src="https://cdn.bytedesk.com/img/input/voice_received.png" alt="[语音]"
              style="padding-top: 10px; padding-bottom: 10px; width: 25px; height: 20px;"
              @click="voiceClicked(message.voiceUrl)"/>
          </div>

          <!-- TODO: 以下类型有待格式化显示 -->
          <div v-if="is_type_video(message)" class="text">{{ message.videoOrShortUrl }}</div>
          <div v-if="is_type_shortvideo(message)" class="text">{{ message.videoOrShortThumbUrl }}</div>
          <div v-if="is_type_location(message)" class="text">{{ message.label }}</div>
          <div v-if="is_type_link(message)" class="text">{{ message.title }}</div>
          <div v-if="is_type_event(message)" class="text">{{ message.content }}</div>

          <div v-if="is_self(message)" class="status" >
              <i v-if="is_sending(message)" class="el-icon-loading" style="font-size:10px"></i>
              <i v-if="is_stored(message)" class="fa fa-times-circle" style="font-size:10px"></i>
              <i v-if="is_received(message)" style="font-size:10px">已收到</i>
              <i v-if="is_read(message)" style="font-size:10px">已读</i>
              <i v-if="is_error(message)" class="iconfont icon-error" style="font-size:10px"></i>
          </div>

        </div>
      </li>
    </ul>
    <el-row :gutter="20">
      <el-col :span="8" :offset="9">
        <el-button size="mini" @click="prePage" :disabled="prePageButtonDisabled">上一页</el-button>
        <el-button size="mini" @click="nextPage" :disabled="nextPageButtonDisabled">下一页</el-button>
        <br/><br/>
        <span style="margin-left: 40px;">消息总条数: {{ this.result.totalElements }}</span>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import * as https from '@/apis/http'
import * as constants from '@/util/constants'
import bus from '@/util/eventbus'

export default {
  name: 'bd-message',
  props: [ 'viewThreadTid' ],
  data () {
    return {
      imageDialogVisible: false,
      currentImageUrl: '',
      currentVoiceUrl: '',
      dialogTableVisible: false,
      currentPage: 0,
      result: {
        first: true,
        last: true,
        totalElements: ''
      },
      messages: [],
      emojiBaseUrl: constants.EMOJI_BASE_URL
    }
  },
  computed: {
    ...mapGetters([ 'userInfo', 'accessToken' ]),
    ...mapState([
      'emotionMap'
    ]),
    show_header () {
      return true
    },
    prePageButtonDisabled () {
      return this.result.first
    },
    nextPageButtonDisabled () {
      return this.result.last
    }
  },
  watch: {
    viewThreadTid (newThreadTid, oldThreadTid) {
      console.log('newThreadTid:', newThreadTid)
      this.currentPage = 0
      this.result = {
        first: true,
        last: true,
        totalElements: ''
      }
      this.messages = []
      this.httpFetch()
    }
  },
  methods: {
    ...mapActions([ 'getMessages' ]),
    imageClicked (imageUrl) {
      console.log('image clicked:', imageUrl)
      this.currentImageUrl = imageUrl
      this.imageDialogVisible = true
    },
    voiceClicked (voiceUrl) {
      console.log('voice clicked:', voiceUrl)
      this.currentVoiceUrl = voiceUrl
      this.dialogTableVisible = true
    },
    is_self (message) {
      return !(message.user.uid === message.thread.visitor.uid)
    },
    // 发送状态
    is_sending (message) {
      return message.status === constants.MESSAGE_STATUS_SENDING
    },
    is_stored (message) {
      return message.status === constants.MESSAGE_STATUS_STORED
    },
    is_received (message) {
      return message.status === constants.MESSAGE_STATUS_RECEIVED
    },
    is_error (message) {
      return message.status === constants.MESSAGE_STATUS_ERROR
    },
    is_read (message) {
      return message.status === constants.MESSAGE_STATUS_READ
    },
    // 消息类型
    is_type_text (message) {
      return message.type === constants.MESSAGE_TYPE_TEXT ||
      message.type === constants.MESSAGE_TYPE_NOTIFICATION_THREAD
    },
    is_type_robot (message) {
      return message.type === constants.MESSAGE_TYPE_ROBOT
    },
    is_type_image (message) {
      return message.type === constants.MESSAGE_TYPE_IMAGE
    },
    is_type_file (message) {
      return message.type === constants.MESSAGE_TYPE_FILE
    },
    is_type_voice (message) {
      return message.type === constants.MESSAGE_TYPE_VOICE
    },
    is_type_video (message) {
      return message.type === constants.MESSAGE_TYPE_VIDEO
    },
    is_type_shortvideo (message) {
      return message.type === constants.MESSAGE_TYPE_SHORT_VIDEO
    },
    is_type_location (message) {
      return message.type === constants.MESSAGE_TYPE_LOCATION
    },
    is_type_link (message) {
      return message.type === constants.MESSAGE_TYPE_LINK
    },
    is_type_event (message) {
      return message.type === constants.MESSAGE_TYPE_EVENT
    },
    is_type_questionnaire (message) {
      return message.type === constants.MESSAGE_TYPE_QUESTIONNAIRE
    },
    is_type_company (message) {
      return message.type === constants.MESSAGE_TYPE_COMPANY
    },
    is_type_workGroup (message) {
      return message.type === constants.MESSAGE_TYPE_WORK_GROUP
    },
    is_type_notification (message) {
      return message.type !== constants.MESSAGE_TYPE_NOTIFICATION_THREAD &&
      message.type.startsWith(constants.MESSAGE_TYPE_NOTIFICATION)
    },
    player_url () {
      return constants.VOICE_PLAYER_BASE_URL + this.currentVoiceUrl
    },
    //  在发送信息之后，将输入的内容中属于表情的部分替换成emoji图片标签
    //  再经过v-html 渲染成真正的图片
    replaceFace (content) {
      var emotionMap = this.emotionMap
      var reg = /\[[\u4E00-\u9FA5NoOK]+\]/g
      var matchresult = content.match(reg)
      var result = content
      if (matchresult) {
        for (var i = 0; i < matchresult.length; i++) {
          result = result.replace(matchresult[i], '<img height=\'25px\' width=\'25px\' style=\'margin-top:5px;\' src=\'' + this.emojiBaseUrl + emotionMap[matchresult[i]] + '\'>')
        }
      }
      return result
    },
    handleImageDialogClose (done) {
      done()
    },
    scrollToBottom () {
      // 聊天记录滚动到最底部
      let vm = this
      this.$nextTick(() => {
        const ul = vm.$refs.list
        if (ul != null) {
          ul.scrollTop = ul.scrollHeight
        }
      })
    },
    prePage () {
      this.currentPage -= 1
      this.httpFetch()
    },
    nextPage () {
      this.currentPage += 1
      this.httpFetch()
    },
    httpFetch () {
      https.getThreadMessages(this.viewThreadTid, this.currentPage, 100, response => {
        console.log(response)
        this.result = response.data
        response.data.content.forEach(message => {
          this.messages.unshift(message)
        })
      }, error => {
        console.log(error)
      })
    }
  },
  created () {
    console.log('created:', this.viewThreadTid)
    this.httpFetch()
  },
  mounted () {
    // 通知界面滚动到底部
    bus.$on(constants.EVENT_BUS_MESSAGE_SCROLL_TO_BOTTOM, () => {
      // console.log('scroll to bottom')
      let vm = this
      vm.$nextTick(() => {
        const ul = vm.$refs.list
        if (ul != null) {
          ul.scrollTop = ul.scrollHeight
        }
      })
    })
  },
  filters: {
    datetime (value) {
      if (typeof value === 'string') {
        return moment(value).format('YYYY-MM-DD HH:mm:ss')
      } else {
        return value
      }
    }
  }
}
</script>

<style scoped>
.pullrefresh {
  margin-top: 20px;
  text-align: center;
  font-size: 10px;
  color: blue;
  cursor: pointer;
}
#bd-message {
  width: calc(100% - 20px);
  height: calc(100% - 100px);
  padding-left: 10px;
  padding-bottom: 20px;
  overflow-y: hidden;
}
.bd-message-ul {
  font-size: 16px;
  height: calc(100% - 50px);
  margin: 0;
  overflow-y: auto;
  padding: 0;
}
li {
  margin-bottom: 15px;
  clear: both;
}
.main {
  margin-left: 0px;
}
.timestamp {
  margin: 10px 0;
  text-align: center;
  font-size: 10px;
}
.timestamp span {
  display: inline-block;
  padding: 0 8px;
  color: #fff;
  border-radius: 5px;
  color: #bbbbbb;
}
.avatar {
  float: left;
  margin: 0 10px 0 0;
  border-radius: 3px;
}
.name {
  text-align: left;
  font-size: 10px;
}
.text {
  float: left;
  position: relative;
  padding: 2px 10px 0px;
  max-width: calc(100% - 40px);
  min-height: 30px;
  line-height: 2.5;
  font-size: 12px;
  text-align: left;
  word-break: break-all;
  background-color: #dddddd;
  border-radius: 4px;
}
.text:before {
  content: " ";
  position: absolute;
  top: 9px;
  right: 100%;
  border: 6px solid transparent;
  border-right-color: #dddddd;
}
.self {
  text-align: right;
}
.self .avatar {
  float: right;
  margin: 0 0 0 10px;
}
.self .name {
  text-align: right;
  font-size: 10px;
}
.self .text {
  float: right;
  background-color: #b2e281;
}
.self .text:before {
  right: inherit;
  left: 100%;
  border-right-color: transparent;
  border-left-color: #b2e281;
}
.self .status {
  float: right;
  margin-right: 8px;
}
.notification {
  text-align: center;
}
.chat li {
  border: none;
}
</style>
